export class UserOnline {
    public static readonly type = '[MessagingState] User online';

    constructor(public uuid: string) {}
}
